"use strict";

import angular from "angular";

/**
 * @component NuSvgError
 * O <nu-svg-error> show an icon of error
 * @this { controllerAs } - svgError
 */

import template from "./svg-error.component.html";
import "./svg-error.scss";

const name = "nuSvgError";
const def = {
    bindings: {},
    controllerAs: "svgError",
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
